import { useField } from 'react-final-form';
import { SpecialFormField as Props, FormFieldOption } from '../../types';
import FormField, { Group } from './FormField';

const SingleCheckbox = ({
  label,
  name,
  ...props
}: Pick<Props, 'name' | 'label'> & Pick<FormFieldOption, 'value'>) => (
  <Group
    name={name}
    options={[{ label: label as string, ...props }]}
    type="checkbox"
    mb="2"
  />
);

const ContactMethodField = ({ name, options, label }: Omit<Props, 'type'>) => {
  const {
    input: { value },
  } = useField(name);

  return (
    <FormField
      name={name}
      options={
        value?.length && options ? (options as FormFieldOption[]) : false
      }
      type="radio"
      label={
        <SingleCheckbox
          name={name}
          label={label}
          value={options ? (options[0] as FormFieldOption).value : '1'}
        />
      }
      required={false}
    />
  );
};

export default ContactMethodField;
